<template>
  <div class="product">
    <headers></headers>
    <div class="product-info1">
      <img src="../assets/images/product/product14.png" alt />
      <div class="product-info1-info1">
        关注公众号
        <div class="infobigbox">
          <p>关注公众号</p>
          <p>微信搜索</p>
          <p>“经理云眼镜”</p>
          <img src="../assets/images/product/product13.png" width="50%" alt />
        </div>
      </div>
    </div>

    <div class="product-info2">
      <div class="product-info2-info1">
        <img src="../assets/images/product/product15.png" alt />
        <p>多渠道顾客拓展</p>
      </div>
      <div class="product-info2-info1">
        <img src="../assets/images/product/product17.png" alt />
        <p>运营信息实时推送</p>
      </div>
      <div class="product-info2-info1">
        <img src="../assets/images/product/product16.png" alt />
        <p>高效多元移动管理</p>
      </div>
    </div>
    <!-- 移动端 -->
    <div class="smallpinzhi">
      <h2>公众号</h2>
      <div class="swiper-container1">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../assets/images/product/product15.png" alt />
            多渠道顾客拓展
          </div>
          <div class="swiper-slide">
            <img src="../assets/images/product/product17.png" alt />
            运营信息实时推送
          </div>
          <div class="swiper-slide">
            <img src="../assets/images/product/product16.png" alt />
            高效多元移动管理
          </div>
        </div>
      </div>
      <div class="swiper-pagination"></div>
    </div>

    <div class="product-info22">微信服务端</div>
    <div class="product-info3">“服务从业人员”</div>
    <div class="product-info4">
      <div class="swiper-container" style="height:400px">
        <div class="swiper-wrapper">
          <div class="swiper-slide">
            <img src="../assets/images/product/product11.png" alt />
            <div class="infobox">
              <p>
                <img src="../assets/配镜助手@2x.png" style="width:53px;height:64px" alt />
              </p>
              <p>验光记录查询/积分查看</p>
              <p>为顾客提供详细的消费记录查询</p>
            </div>
            <span>配镜助手</span>
          </div>
          <div class="swiper-slide">
            <img src="../assets/images/product/product12.png" alt />
            <div class="infobox">
              <p>
                <img src="../assets/定位@2x.png" style="width:48px;height:64px" alt />
              </p>
              <p>附近商家GPS定位</p>
              <p>为顾客提供导航服务，多渠道拓展客源</p>
            </div>
            <span>附近商店</span>
          </div>
          <div class="swiper-slide">
            <img src="../assets/images/product/product11.png" alt />
            <div class="infobox">
              <p>
                <img src="../assets/扫码@2x.png" style="width:65px;height:61px" alt />
              </p>
              <p>扫一扫实时查看</p>
              <p>摒弃过去电话通知取镜的方式</p>
            </div>
            <span>配镜进度</span>
          </div>
          <div class="swiper-slide">
            <img src="../assets/123456.png" alt />
            <div class="infobox">
              <p style="transform: translateY(-15px)">
                <span class="iconfont" style="font-size:60px;color:#fff;">&#xe681;</span>
              </p>
              <p style="transform: translateY(-5px)">提供活动版面</p>
              <p style="transform: translateY(-5px)">商家优惠活动提醒,让顾客惊喜不停</p>
            </div>
            <span>微营销</span>
          </div>
        </div>
      </div>
    </div>

    <!-- 移动端 -->
    <div class="smallinfo4">
      <ul>
        <li>
          <img src="../assets/images/product/product11.png" alt />
          <div class="infobox1">
            <p>
              <img src="../assets/配镜助手@2x.png" alt />
            </p>
            <p>验光记录查询/积分查看</p>
            <p>为顾客提供详细的消费记录查询</p>
          </div>
        </li>
        <li>
          <img src="../assets/images/product/product12.png" alt />
          <div class="infobox1">
            <p>
              <img src="../assets/定位@2x.png" alt />
            </p>
            <p>附近商家GPS定位</p>
            <p>为顾客提供导航服务，多渠道拓展客源</p>
          </div>
        </li>
        <li>
          <img src="../assets/images/product/product11.png" alt />
          <div class="infobox1">
            <p>
              <img src="../assets/扫码@2x.png" alt />
            </p>
            <p>扫一扫实时查看</p>
            <p>摒弃过去电话通知取镜的方式</p>
          </div>
        </li>
        <li>
          <img src="../assets/123456.png" alt />
          <div class="infobox1">
            <p>
              <img src="../assets/商品@2x.png" alt />
            </p>
            <p>提供活动版面</p>
            <p>商家优惠活动提醒,让顾客惊喜不停</p>
          </div>
        </li>
      </ul>
    </div>
    <footers></footers>
  </div>
</template>

<script>
import Swiper from "swiper";
import "../../node_modules/swiper/dist/css/swiper.min.css";
import footer from "../components/footer";
import header from "../components/headers";
export default {
  name: "",
  components: {
    footers: footer,
    headers: header
  },
  data() {
    return {};
  },
  mounted() {
    var mySwiper = new Swiper(".swiper-container", {
      autoplay: true,
      loop: true,
      slidesPerView: 3,
      slidesPerGroup: 3,
      spaceBetween: 20,
      preventClicks: false //默认true
    });
    var mySwiper = new Swiper(".swiper-container1", {
      pagination: {
        el: ".swiper-pagination"
      },
      slidesPerView: 2
    });
  },
  methods: {},
  watch: {}
};
</script>

<style scoped lang="less">
* {
  padding: 0;
  margin: 0;
  list-style: none;
  box-sizing: border-box;
}
@font-face {
  font-family: "iconfont";
  src: url("../assets/iconfont/font_home/iconfont.eot");
  src: url("../assets/iconfont/font_home/iconfont.eot?#iefix")
      format("embedded-opentype"),
    url("../assets/iconfont/font_home/iconfont.woff2") format("woff2"),
    url("../assets/iconfont/font_home/iconfont.woff") format("woff"),
    url("../assets/iconfont/font_home/iconfont.ttf") format("truetype"),
    url("../assets/iconfont/font_home/iconfont.svg#iconfont") format("svg");
}
.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
.product {
  width: 100%;
  .product-info1 {
    width: 100%;
    // height:648px;
    margin-bottom: 60px;
    position: relative;
    @media screen and (max-width: 850px) {
      margin-bottom: 30px;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .product-info1-info1 {
      @media screen and (max-width: 850px) {
        display: none;
      }
      position: absolute;
      bottom: 20%;
      left: 26%;
      width: 180px;
      height: 60px;
      line-height: 60px;
      text-align: center;
      color: #323232;
      font-size: 24px;
      background: rgba(255, 255, 0, 1);
      cursor: pointer;
      .infobigbox {
        position: absolute;
        bottom: 60%;
        right: 0;
        p {
          color: #000;
          text-align: center;
          font-size: 18px;
          line-height: 25px;
        }
        display: none;
      }
      &:hover {
        .infobigbox {
          display: block;
          transition: all 0.2s linear;
        }
      }
    }
  }

  @media screen and (max-width: 850px) {
    .product-info2 {
      display: none !important;
    }
    .smallpinzhi {
      display: block;
    }
    .product-info4 {
      display: none;
    }
  }
  @media screen and (min-width: 850px) {
    .product-info2 {
      display: block;
    }
    .smallpinzhi {
      display: none;
    }
    .smallinfo4 {
      display: none;
    }
  }
  .product-info2 {
    width: 70%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    color: #323232;
    margin: 0 auto;
    display: flex;
    justify-content: center;
    // padding: 0 20px;
    .product-info2-info1 {
      width: 27%;
      height: 80px;
      line-height: 80px;
      padding: 0 30px;
      display: flex;
      justify-content: center;
      cursor: pointer;
      margin-right: 45px;
      img {
        width: 42px;
        height: 42px;
        margin-right: 10px;
        margin-top: 20px;
      }
      &:hover {
        box-shadow: 0px 4px 5px 0px rgba(37, 143, 252, 0.2);
        border-radius: 2px;
      }
      p {
        white-space: nowrap; /*规定段落中的文本不进行换行*/
        // overflow: hidden; /*内容会被修剪，并且其余内容是不可见的。*/
        // text-overflow: ellipsis; /*显示省略号来代表被修剪的文本*/
      }
    }
  }
  .smallpinzhi {
    h2 {
      font-size: 16px;
      color: #2e2e2e;
      font-weight: 400;
      margin: 11px 0;
      position: relative;
      padding-left: 28px;

      &::after {
        content: "";
        background-color: #258ffc;
        border-radius: 5.5px;
        width: 4px;
        height: 16px;
        overflow: hidden;
        position: absolute;
        top: 3px;
        left: 13px;
      }
    }
    .swiper-slide {
      padding: 12px;
      white-space: nowrap;
      img {
        width: 24px;
        vertical-align: middle;
      }
      vertical-align: middle;
    }
    .swiper-pagination {
      width: 100%;
      /deep/.swiper-pagination-bullet {
        height: 2px;
      }
    }
  }
  .product-info22 {
    width: 20%;
    font-size: 28px;
    font-family: MicrosoftYaHei;
    // font-weight:bold;
    color: rgba(50, 50, 50, 1);
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
    margin-top: 60px;
    margin-bottom: 20px;
    @media screen and (max-width: 850px) {
      width: 100%;
      font-size: 14px;
      margin-top: 30px;
      margin-bottom: 0px;
    }
  }
  .product-info3 {
    width: 20%;
    font-size: 18px;
    font-family: MicrosoftYaHei;
    // font-weight:bold;
    color: rgba(50, 50, 50, 1);
    line-height: 30px;
    text-align: center;
    margin: 0 auto;
    @media screen and (max-width: 850px) {
      width: 100%;
      font-size: 14px;
      margin-bottom: 20px;
    }
  }
  .product-info4 {
    width: 70%;
    height: 400px;
    margin: 0 auto;
    margin-bottom: 200px;
    margin-top: 60px;
    .swiper-container {
      width: 100%;
      height: 300px;
      .swiper-slide {
        height: 300px;
        img {
          width: 400px;
          height: 300px;
        }
        span {
          width: 100%;
          display: inline-block;
          text-align: center;
          line-height: 40px;
          margin-top: 30px;
          color: #000;
        }
        .infobox {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: #fff;
          width: 100%;
          p {
            text-align: center;
            font-size: 18px;
            width: 100%;
            line-height: 30px;
          }
          display: none;
        }
        &:hover {
          .infobox {
            display: block;
          }
        }
      }
    }
  }
  .smallinfo4 {
    width: 100%;
    padding: 0 15px;
    ul {
      margin: 0 auto;
      overflow: hidden;
      // display: flex;
      li {
        position: relative;
        float: left;
        width: 164px;
        // margin-right: 5px;
        margin-bottom: 20px;
        &:nth-of-type(even) {
          margin-right: 0;
          float: right;
        }
        img {
          display: block;
          width: 100%;
        }
        .infobox1 {
          position: absolute;
          top: 50%;
          left: 0;
          transform: translateY(-50%);
          width: 100%;
          p {
            text-align: center;
            font-size: 10px;
            color: #fff;
            img {
              display: inline-block;
              width: 30px;
            }
          }
        }
      }
    }
  }
}
</style>
